import { Box, Paper, Tab, Tabs } from "@mui/material";

import { SYSTEMS } from "../../../constants";
import { SystemStatistics } from "./SystemStatistics";
import { useMemo } from "react";

const aggregateStatistics = (statistics) => {
    return statistics.reduce(
        (acc, stat) => ({
            system: "All",
            plannedSiteCount:
                acc.plannedSiteCount + (stat.plannedSiteCount || 0),
            receivedSiteCount:
                acc.receivedSiteCount + (stat.receivedSiteCount || 0),
            plannedTotalMissionsCount:
                acc.plannedTotalMissionsCount +
                (stat.plannedTotalMissionsCount || 0),
            receivedTotalMissionsCount:
                acc.receivedTotalMissionsCount +
                (stat.receivedTotalMissionsCount || 0),
            plannedFeatureCount:
                acc.plannedFeatureCount + (stat.plannedFeatureCount || 0),
            receivedFeatureCount:
                acc.receivedFeatureCount + (stat.receivedFeatureCount || 0),
        }),
        {
            system: "All",
            plannedSiteCount: 0,
            receivedSiteCount: 0,
            plannedTotalMissionsCount: 0,
            receivedTotalMissionsCount: 0,
            plannedFeatureCount: 0,
            receivedFeatureCount: 0,
        }
    );
};

export const AllSystemsStatistics = ({
    statistics,
    selectedSystem,
    setSelectedSystem,
}) => {
    const literalStats = statistics.filter((s) => s.system === SYSTEMS.LITERAL);
    const nonLiteralStats = statistics.filter(
        (s) => s.system !== SYSTEMS.LITERAL
    );
    const isSingle = statistics.length === 1;
    const showAllTab = nonLiteralStats.length > 1;

    const tabs = useMemo(() => {
        const nonLiteralTabs = nonLiteralStats.map((statistic) => ({
            label: statistic.system,
            statistic,
        }));

        const tabs = [];

        if (showAllTab) {
            tabs.push({
                label: "All",
                statistic: aggregateStatistics(nonLiteralStats),
            });
        }

        tabs.push(...nonLiteralTabs);

        if (literalStats.length === 1) {
            tabs.push({
                label: SYSTEMS.LITERAL,
                statistic: literalStats[0],
            });
        }

        return tabs;
    }, [showAllTab, literalStats, nonLiteralStats]);

    const selectedTabIndex = useMemo(
        () => tabs.findIndex((tab) => tab.label === selectedSystem),
        [selectedSystem, tabs]
    );

    return isSingle ? (
        <SystemStatistics statistic={statistics[0]} showSystemLabel={true} />
    ) : (
        <Paper sx={{ px: 0.5, py: "2px" }} elevation={2}>
            <Box sx={{ height: 30, mb: 0.5 }}>
                <Tabs
                    value={selectedTabIndex}
                    sx={{
                        ".MuiTabs-scroller": { height: "30px" },
                        ".MuiTab-root": {
                            minHeight: "30px",
                        },
                    }}
                >
                    {tabs.map((tab, i) => (
                        <Tab
                            key={i}
                            label={tab.label}
                            sx={{
                                px: 0,
                                py: 0,
                            }}
                            onClick={() => setSelectedSystem(tab.label)}
                        />
                    ))}
                </Tabs>
            </Box>
            <SystemStatistics statistic={tabs[selectedTabIndex].statistic} />
        </Paper>
    );
};
